import {
  ArrowDownTrayIcon,
  ArrowUpIcon,
  ArrowDownIcon,
  ArrowLeftIcon,
  PlusIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";
import React, { useContext, useEffect, useState, useRef } from "react";
import Image from "../../Tags/Image";
import { useMutation, useQueryClient } from "react-query";
import { enrichCSVMapColumns } from "../../../apis/enrich";
import SharedDataContext from "../../../SharedDataContext";
import { toast } from "react-hot-toast";
import { isEmptyObject, returnArray } from "../../../utils/GenericFn";
import ConfirmModal from "../../Modals/ConfirmModal";
import { useQuery } from "react-query";
import { getEnrichmentIntegrations } from "../../../apis/workspace/integrations";
import Sortable from "sortablejs";
import { Button } from "../../ui/button";
import { Info, LucideUploadCloud, X } from "lucide-react";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "../../ui/breadcrumb";
import NavAnchor from "../../Tags/NavAnchor";
import { useCaptureEvent } from "../../../hooks/useCaptureEvent";
import axios from "axios";
import Cookies from "js-cookie";
import { Badge } from "../../ui/badge";
import GenericModal from "../../GenericModal";
import useModal from "../../GenericModal/useModal";
import {
  getAutoVerifyByValueForEnrichmentMode,
  getEnrichmentRequirementByValue,
} from "../../../axios/constant";
import { Switch } from "../../ui/switch";
import AlertTag from "../../Alerts/Alert";
// Wizard Steps Component
const WizardSteps = ({ currentStep, children, importType, onStepClick }) => {
  const baseSteps = [
    {
      number: 1,
      title: "Select import type",
      description: "Tell us which object you want to import/enrich",
    },
    {
      number: 2,
      title: "Upload CSV",
      description: "Upload the CSV you want to import/enrich",
    },
    {
      number: 3,
      title: "Map columns",
      description: "Tell us which columns in your CSV mean what",
    },
  ];

  const peopleSteps = [
    {
      number: 4,
      title: "Choose data points",
      description: "Choose the data points you would like to enrich the contacts with",
    },
    {
      number: 5,
      title: "Configure provider priority",
      description: "Tell us if you would like to use a custom provider priority for this enrichment",
    },
    {
      number: 6,
      title: "Finalise import",
      description: "Confirm everything before we shoot off!",
    },
  ];

  const companySteps = [
    {
      number: 4,
      title: "Finalise import",
      description: "Confirm everything before we shoot off!",
    },
  ];

  const steps = [...baseSteps, ...(importType === "Company" ? companySteps : peopleSteps)];

  // Define active/completed step SVG
  const ActiveStepSvg = ({ isCompleted }) => (
    <svg width="25" height="24" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 0 C8.04071716 5.46768767 14.35713546 11.78672485 16.953125 21.328125 C17.97008074 32.73931439 17.08780568 41.52074309 9.640625 50.578125 C3.75028057 56.89640044 -1.9995096 60.87830798 -10.81640625 61.6640625 C-22.23808647 61.92046185 -29.76998744 60.10045244 -38.2578125 52.1875 C-45.41707366 44.7468705 -47.46537447 37.63799487 -47.41040039 27.37304688 C-47.154444 17.46241552 -43.06295379 11.07888989 -36.046875 4.328125 C-26.55128048 -3.80505814 -11.27874483 -6.1129075 0 0 Z"
        className="fill-[#8058D9] dark:fill-[#7F56D9]"
        transform="translate(47.046875,2.671875)"
      />
      <path
        d="M0 0 C8.04071716 5.46768767 14.35713546 11.78672485 16.953125 21.328125 C17.97008074 32.73931439 17.08780568 41.52074309 9.640625 50.578125 C3.75028057 56.89640044 -1.9995096 60.87830798 -10.81640625 61.6640625 C-22.23808647 61.92046185 -29.76998744 60.10045244 -38.2578125 52.1875 C-45.41707366 44.7468705 -47.46537447 37.63799487 -47.41040039 27.37304688 C-47.154444 17.46241552 -43.06295379 11.07888989 -36.046875 4.328125 C-26.55128048 -3.80505814 -11.27874483 -6.1129075 0 0 Z M-35.3828125 16.01171875 C-39.69498372 22.01434207 -39.91523726 28.15271054 -39.046875 35.328125 C-36.7704698 42.19969234 -31.95580205 47.28811995 -26.046875 51.328125 C-19.95513856 54.29436268 -12.95319606 54.62220671 -6.51171875 52.48828125 C0.05359274 49.14368861 5.04222437 44.06684362 8.390625 37.515625 C9.63144691 30.48430085 10.10619438 23.59603687 6.4140625 17.24609375 C1.87004252 11.28054881 -3.44457613 6.39511432 -11.046875 5.328125 C-22.26366598 4.1843075 -28.10245461 7.6726634 -35.3828125 16.01171875 Z"
        className="fill-[#A07AED] dark:fill-[#9370DB]"
        transform="translate(47.046875,2.671875)"
      />
      <path
        d="M0 0 C6.37941264 4.9925838 10.29700078 10.20220399 11.875 18.25 C12.91383772 27.54182628 10.61126309 34.87480459 4.875 42.25 C-2.26963789 48.92868324 -9.08151085 51.64490376 -18.734375 51.453125 C-27.4121896 50.71579435 -33.39207027 46.68374879 -39.125 40.25 C-44.05527458 32.86137914 -45.23317475 24.67741353 -43.734375 15.984375 C-41.7688851 8.77757868 -37.20664105 2.9292689 -30.96484375 -1.16796875 C-20.32951343 -6.67448557 -10.26158424 -5.74648718 0 0 Z M-36.4609375 9.93359375 C-40.77310872 15.93621707 -40.99336226 22.07458554 -40.125 29.25 C-37.8485948 36.12156734 -33.03392705 41.20999495 -27.125 45.25 C-21.03326356 48.21623768 -14.03132106 48.54408171 -7.58984375 46.41015625 C-1.02453226 43.06556361 3.96409937 37.98871862 7.3125 31.4375 C8.55332191 24.40617585 9.02806938 17.51791187 5.3359375 11.16796875 C0.79191752 5.20242381 -4.52270113 0.31698932 -12.125 -0.75 C-23.34179098 -1.8938175 -29.18057961 1.5945384 -36.4609375 9.93359375 Z"
        className="fill-[#F8F5FD] dark:fill-[#22262F]"
        transform="translate(48.125,8.75)"
      />

      {/* Center dot for current step or checkmark for completed step */}
      {!isCompleted ? (
        <path
          d="M0 0 C4.0743356 0.84881992 5.54405875 2.30225596 8 5.625 C8.54667869 8.97340698 8.34038506 10.83785954 7 13.9375 C3.96275614 16.5001745 0.90933118 16.79839775 -3 16.625 C-5.4375 15.6875 -5.4375 15.6875 -7 13.625 C-7.95798882 10.88704431 -8.32609912 8.51491291 -8 5.625 C-5.60540961 2.14195943 -4.14822958 0.8642145 0 0 Z"
          className="fill-[#FAF8FD] dark:fill-white"
          transform="translate(32,23.375)"
        />
      ) : (
        <path
          d="M22 32L30 40L42 28"
          stroke="white"
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
    </svg>
  );

  // Define inactive step SVG
  const InactiveStepSvg = () => (
    <svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Outer circle */}
      <circle cx="16" cy="16" r="15" className="fill-[#FAFAFA] dark:fill-[#1A1D25]" />

      {/* Border */}
      <circle cx="16" cy="16" r="14.5" className="stroke-[#E9EAEB] dark:stroke-[#2E3340]" strokeWidth="1" />

      {/* Center dot */}
      <circle cx="16" cy="16" r="4" className="fill-[#D5D7DA] dark:fill-[#4D5562]" />
    </svg>
  );

  return (
    <div>
      <div className="flex flex-col gap-3">
        {steps.map((step, index) => (
          <div
            key={step.number}
            className={`flex items-start relative bg-background dark:bg-[#0C111D] border border-border dark:border-[#1F242F] p-6 rounded-lg ${
              step.number !== currentStep
                ? "cursor-pointer hover:border-violet-400 hover:shadow-sm transition-all"
                : ""
            }`}
            onClick={() => {
              if (step.number < currentStep && onStepClick) {
                onStepClick(step.number);
              }
            }}
            title={step.number !== currentStep ? "" : ""}
          >
            {/* Vertical connector line */}
            {index < steps.length - 1 && currentStep === step.number && (
              <div
                className="absolute left-9 top-9 w-0.5 bottom-9 bg-violet-600 dark:bg-[#61656C]"
                style={{
                  transform: "translateX(-50%)",
                  zIndex: 0,
                }}
              ></div>
            )}

            {/* Step SVG based on state */}
            <div className="relative z-10 mt-3 mr-3">
              {currentStep >= step.number ? (
                <ActiveStepSvg isCompleted={currentStep > step.number} />
              ) : (
                <InactiveStepSvg />
              )}
            </div>

            {/* Step content */}
            <div className="py-2 flex-grow">
              <div className="flex flex-col">
                <h3
                  className={`font-semibold text-sm ${
                    currentStep >= step.number
                      ? "text-[#6941C6] dark:text-[#CECFD2] "
                      : "text-[#414651] dark:text-[#CECFD2]"
                  }`}
                >
                  {step.title}
                </h3>
                <p
                  className={`text-sm font-normal ${
                    currentStep >= step.number
                      ? "text-[#7F56D9] dark:text-[#94979C] "
                      : "text-[#535862] dark:text-[#94979C]"
                  }`}
                >
                  {step.description}
                </p>
              </div>

              {/* Display content for the current step */}
              {currentStep === step.number && <div className="mt-4">{children}</div>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default function UploadWizard({ onComplete }) {
  const captureEvent = useCaptureEvent();
  const queryClient = useQueryClient();
  const userData = useContext(SharedDataContext);
  const { activeWorkspace } = userData || {};

  // Wizard state variables
  const [currentStep, setCurrentStep] = useState(1);
  const [importType, setImportType] = useState("People");
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);
  const [isFileUploading, setIsFileUploading] = useState(false);
  const [tags, setTags] = useState([]);
  const [tagInput, setTagInput] = useState("");
  const [autoVerify, setAutoVerify] = useState(true);
  const { isOpen, openModal, closeModal } = useModal(false);
  const { isOpen: isOpenMap, openModal: openModalMap, closeModal: closeModalMap } = useModal();
  const [csvResponse, setCSVResponse] = useState(null);
  const [predictedMapping, setPredictedMapping] = useState(null);
  const [newMappingOfCSVCols, setNewMappingOfCSVCols] = useState();
  const [showHide, setShowHide] = useState(true);
  const [enrichmentType, setEnrichmentType] = useState(false);
  const [enrichmentTypeValue, setEnrichmentTypeValue] = useState("Email");
  const [showIntegrations, setShowIntegrations] = useState(false);
  const [overRideMapColumn, setOverRideMapColumn] = useState({
    oldkey: null,
    newkey: null,
    index: null,
  });
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [openConfirmModalType, setOpenConfirmModalType] = useState("");
  const [currentEnrichmentId, setCurrentEnrichmentId] = useState("");
  const [mapColumnsError, setMapColumnsError] = useState(null);

  // Integration state
  const [logos, setLogos] = useState({});
  const [noIntegration, setNoIntegration] = useState(false);
  const [integrations, setIntegrations] = useState([]);
  const [integrationConfigPriorityList, setIntegrationConfigPriorityList] = useState([]);
  const [activeIntegrations, setActiveIntegrations] = useState([]);
  const [integrationOrder, setIntegrationOrder] = useState([]);
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [priorityChanged, setPriorityChanged] = useState(false);
  const sortableContainer = useRef(null);
  const currentImportType = csvResponse?.enrichment_type || importType;
  // Wizard navigation functions
  const goToNextStep = (skipProvider = false) => {
    const nextStep = currentStep + 1;

    if (currentImportType === "Company") {
      if (currentStep === 3) {
        setCurrentStep(4);
      } else {
        setCurrentStep(nextStep);
      }
    } else {
      if (currentStep === 4 && skipProvider) {
        setCurrentStep(6);
      } else {
        setCurrentStep(nextStep);
      }
    }
  };

  // Update the goBackStep function
  const goBackStep = () => {
    if (currentImportType === "Company" && currentStep === 4) {
      setCurrentStep(3);
    } else {
      setCurrentStep((prevStep) => prevStep - 1);
    }
  };

  const cancelProcess = () => {
    setCSVResponse(null);
    setSelectedFile(null);
    setCurrentStep(1);
    setEnrichmentType(false);
    setEnrichmentTypeValue("Email");
    setTags([]);
    setAutoVerify(false);

    // Call the onComplete callback to go back to the list view
    if (onComplete) {
      onComplete();
    }
  };

  // File handling functions
  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleFileDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    setSelectedFile(file);
  };

  // File size formatting
  const formatFileSize = (bytes) => {
    const KB = 1024;
    const MB = KB * 1024;

    if (bytes < MB) {
      const fileSizeKB = (bytes / KB).toFixed(2);
      return `${fileSizeKB} KB`;
    } else {
      const fileSizeMB = (bytes / MB).toFixed(2);
      return `${fileSizeMB} MB`;
    }
  };

  // Tag management
  const addTag = () => {
    if (!tags.includes(tagInput) && tagInput.trim()) {
      setTags([...tags, tagInput]);
      setTagInput("");
    }
  };

  const removeTag = (tagToRemove) => {
    setTags(tags.filter((tag) => tag !== tagToRemove));
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addTag();
    }
  };

  // CSV upload handler
  const handleUploadCSV = () => {
    if (!selectedFile) return;

    setIsFileUploading(true);
    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("enrichment_type", importType);

    const cookieName = process.env.REACT_APP_PR_ACCESS_TOKEN
      ? process.env.REACT_APP_PR_ACCESS_TOKEN
      : "accessToken";
    const token = Cookies.get(cookieName);

    const config = {
      headers: {
        "X-Workspace-Id": activeWorkspace?.id,
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    };

    axios
      .post(`${process.env.REACT_APP_NUCLEUS_API_BASE_URL}/api/v2/enrich/csv/upload`, formData, config)
      .then((response) => {
        setCSVResponse(response.data.list);
        setCurrentStep(3); // Move to column mapping step
        setIsFileUploading(false);
        captureEvent("BLE_UploadCSVWizard_UploadSuccess");
      })
      .catch((error) => {
        console.error(error);
        toast.error("Failed to upload CSV file");
        setIsFileUploading(false);
      });
  };

  // Integration data
  const { refetch: refetchIntegrations } = useQuery(
    ["get_integrations", activeWorkspace?.id],
    () =>
      getEnrichmentIntegrations({
        options: {
          headers: {
            "X-Workspace-Id": activeWorkspace?.id,
          },
        },
      }),
    {
      enabled: !!activeWorkspace,
      refetchOnWindowFocus: false,
      staleTime: Infinity, // never mark as stale
      cacheTime: 1000 * 60 * 60 * 24, // 24 hours
      onSuccess: (data) => {
        const installedIntegrations = (data.installed || []).filter((integration) =>
          integration.integration?.capabilities?.includes("csv_contact_enrichment")
        );
        setIntegrations(installedIntegrations);
        setActiveIntegrations(installedIntegrations.map((integration) => integration.id));
        if (data && data.available && data.available.length > 0) {
          const keylogos = data.available.reduce((acc, curr) => {
            acc[curr.key] = curr?.logo;
            return acc;
          }, {});
          setLogos(keylogos);
        }
        if (data && data.installed && data.installed.length === 0) {
          setNoIntegration(true);
        } else {
          setNoIntegration(false);
        }
      },
      onError: (error) => {
        console.error(error);
      },
    }
  );

  useEffect(() => {
    if (activeWorkspace && activeWorkspace.id) {
      refetchIntegrations();
    }
  }, [activeWorkspace]);

  // Integration priority handling
  useEffect(() => {
    if (integrationOrder?.length > 0) {
      // Convert string IDs in integrationOrder to numbers
      const numericOrder = integrationOrder
        .map((id) => {
          const num = Number(id);
          return isNaN(num) ? null : num;
        })
        .filter((id) => id !== null);

      // Filter based on activeIntegrations to ensure only active ones are included
      const filteredOrder = numericOrder.filter((id) => activeIntegrations.includes(id));

      // If we have a valid filtered order, use it; otherwise default to activeIntegrations
      const finalList = filteredOrder.length > 0 ? filteredOrder : activeIntegrations;

      // Update integrationConfigPriorityList with the final list
      setIntegrationConfigPriorityList(finalList);
    } else if (activeIntegrations.length > 0) {
      // If no order exists but we have active integrations, use those directly
      setIntegrationConfigPriorityList(activeIntegrations);
    }
  }, [integrationOrder, activeIntegrations]);

  // Existing useEffect for integrations
  useEffect(() => {
    if (integrations?.length > 0) {
      setIsDataLoaded(true);
    }
    return () => {
      setIsDataLoaded(false);
    };
  }, [integrations]);

  // Initialize Sortable for integration priority
  useEffect(() => {
    // Initialize Sortable when in Step 5 or when showIntegrations is true
    if (
      sortableContainer?.current &&
      (currentStep === 5 || showIntegrations) &&
      isDataLoaded &&
      integrations.length > 0
    ) {
      // Cleanup any existing instance first
      const existingSortable = Sortable.get(sortableContainer.current);
      if (existingSortable) {
        existingSortable.destroy();
      }

      const sortable = new Sortable(sortableContainer.current, {
        animation: 150,
        onEnd: () => {
          // Update the state with the new order
          const newOrder = sortable.toArray();
          setIntegrationOrder(newOrder);
          setPriorityChanged(true);
        },
        dataIdAttr: "data-id",
      });

      // Set initial order after a brief delay to ensure DOM is ready
      setTimeout(() => {
        const initialOrder = sortable.toArray();

        if (initialOrder?.length > 0) {
          setIntegrationOrder(initialOrder);
        } else if (activeIntegrations?.length > 0) {
          // Fallback: use activeIntegrations if sortable.toArray() returns nothing
          const stringIds = activeIntegrations.map((id) => id.toString());
          setIntegrationOrder(stringIds);
        }
      }, 100);

      return () => {
        sortable.destroy();
      };
    }
  }, [currentStep, isDataLoaded, showIntegrations, activeIntegrations, integrations.length]);

  // Column mapping logic
  const predictMapping = (header, sampleRecord, mappingColumns) => {
    const result = {};

    for (let i = 0; i < header.length; i++) {
      const headerValue = header[i].trim();
      let headerKey = null;
      let headerKeyIndex = null;

      for (const key in mappingColumns) {
        if (mappingColumns[key].toLowerCase().includes(headerValue.toLowerCase())) {
          headerKey = key;
          headerKeyIndex = i;
          break;
        }
      }

      if (headerKey) {
        result[headerKey] = {
          value: sampleRecord[i],
          header_key: headerValue,
          header_key_index: headerKeyIndex,
        };
      } else {
        result[headerValue] = sampleRecord[i];
      }
    }
    setPredictedMapping(result);
  };

  useEffect(() => {
    if (csvResponse && csvResponse.header && csvResponse.sample_record && csvResponse.mapping_columns) {
      predictMapping(csvResponse.header, csvResponse.sample_record, csvResponse.mapping_columns);
    }
  }, [csvResponse]);

  const extractKeyIndices = (result) => {
    const keyIndices = {};
    for (const key in result) {
      if (result[key] && result[key].header_key_index !== undefined) {
        keyIndices[key] = result[key].header_key_index;
      }
    }
    return keyIndices;
  };

  useEffect(() => {
    if (predictedMapping) {
      setNewMappingOfCSVCols(extractKeyIndices(predictedMapping));
    }
  }, [predictedMapping]);

  const handleChangeCSVColumn = (index, key, confirm = false) => {
    const updatedMapping = { ...newMappingOfCSVCols };

    // Check if the provided index already exists in updatedMapping
    const existingKey = Object.keys(updatedMapping).find((k) => updatedMapping[k] === +index);

    if (!confirm && index !== "") {
      if (existingKey) {
        setOverRideMapColumn({
          newkey: key,
          oldkey: existingKey,
          index: index,
        });
        return;
      }
    }
    if (confirm) {
      setOverRideMapColumn({
        oldkey: null,
        newkey: null,
        index: null,
      });
      delete updatedMapping[existingKey];
    }

    if (index === "") {
      delete updatedMapping[key];
    } else {
      updatedMapping[key] = +index;
    }
    setNewMappingOfCSVCols(updatedMapping);
  };

  // Provider priority handling
  const handleCheckboxChange = (integrationId, isChecked) => {
    if (isChecked) {
      // Add to the list if checked
      setActiveIntegrations((prevList) => [...prevList, integrationId]);
      setPriorityChanged(true);
    } else {
      // Prevent unchecking if this is the last integration
      if (activeIntegrations.length === 1) {
        alert("Enrichment List must contain at least one integration");
        return;
      }
      // Remove from the list if unchecked
      setActiveIntegrations((prevList) => prevList.filter((id) => id !== integrationId));
      setPriorityChanged(true);
    }
  };

  // LinkedIn URL validation
  const isLinkedInURL = (url) => {
    const cleanedUrl = url.replace(/[/,]$/, "");
    const pattern = /^https?:\/\/(www\.)?linkedin\.com\/.+/i;
    return pattern.test(cleanedUrl);
  };

  const scrollToTopForAlert = () => {
    if (typeof window === "undefined") return;

    const wizardEl = document.getElementById("UploadContactsWizard");
    if (wizardEl?.scrollIntoView) {
      wizardEl.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // enrich column api
  const enrichCSVMapColumnsFn = useMutation("enrich_columns", enrichCSVMapColumns, {
    onSuccess(data, variables, context) {
      setMapColumnsError(null);
      toast.success(data.message);
      queryClient.invalidateQueries("get_enrichment_list");
      setEnrichmentTypeValue("Email");
      setEnrichmentType(false);
      setShowIntegrations(false);
      setPriorityChanged(false);
      // Call onComplete to go back to the list view and refresh the data
      if (onComplete) {
        onComplete();
      }
    },
    onError(error) {
      console.log("setMapColumnsError", error);
      const status = error?.status;
      const responseData = error?.data;

      if (status === 402 || status === 403) {
        scrollToTopForAlert();
        setMapColumnsError({
          status,
          title: responseData?.title,
          message: responseData?.message,
        });
        return;
      }
    },
  });

  const handleEnrichCSVMapColumns = () => {
    setMapColumnsError(null);

    const payload = {
      listId: csvResponse.id,
      data: {
        mapping: newMappingOfCSVCols,
      },
      options: {
        headers: { "X-Workspace-Id": activeWorkspace?.id },
      },
    };

    if (csvResponse && csvResponse?.enrichment_type === "Company") {
      // For Company type, set requirements and verify to empty arrays
      payload.data.requirements = [];
      payload.data.settings = {
        verify: [],
      };
    } else {
      // For People type, add requirements and verify settings
      payload.data.requirements = getEnrichmentRequirementByValue(enrichmentTypeValue);

      if (autoVerify) {
        payload.data.settings = {
          verify: getAutoVerifyByValueForEnrichmentMode(autoVerify, enrichmentTypeValue),
        };
      }

      // Send integration priorities only if changed (unselected/reordered)
      if (integrationConfigPriorityList && integrationConfigPriorityList.length > 0) {
        const defaultPriorityOrder = integrations
          .filter((integration) => activeIntegrations.includes(integration.id))
          .map((integration) => integration.id);

        const hasCustomPriorityOrder =
          priorityChanged ||
          defaultPriorityOrder.length !== integrationConfigPriorityList.length ||
          integrationConfigPriorityList.some((id, index) => id !== defaultPriorityOrder[index]);

        if (hasCustomPriorityOrder) {
          payload.data.integration_config_priority_list = integrationConfigPriorityList;
        }
      }
    }

    enrichCSVMapColumnsFn.mutate(payload);
  };
  const handleStepClick = (stepNumber) => {
    if (stepNumber !== currentStep) {
      setCurrentStep(stepNumber);
      captureEvent("BLE_UploadWizard_StepTileClick", {
        from_step: currentStep,
        to_step: stepNumber,
      });
    }
  };

  // Render functions for wizard steps
  const renderStep1ImportType = () => {
    return (
      <div>
        <div className="flex mb-6 space-x-3 pr-6">
          {/* Contacts Selection */}
          <div
            onClick={() => setImportType("People")}
            className={`flex flex-col items-center justify-center border-2 p-6 rounded-lg cursor-pointer transition-all w-1/2 ${
              importType === "People"
                ? "bg-[#F9F5FF] dark:bg-[#22262F] border-violet-400 dark:border-violet-600 shadow-sm dark:text-[#F7F7F7]"
                : "bg-background border border-border text-purple-500  shadow-sm"
            }`}
          >
            <svg width="34" height="30" viewBox="0 0 34 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M26.0002 20.7553C28.1841 21.8524 30.0564 23.6129 31.4231 25.8144C31.6937 26.2504 31.8291 26.4684 31.8759 26.7702C31.9709 27.3837 31.5515 28.1378 30.9801 28.3805C30.699 28.5 30.3828 28.5 29.7502 28.5M23.0002 14.2984C25.2228 13.1938 26.7502 10.9003 26.7502 8.25C26.7502 5.59971 25.2228 3.30617 23.0002 2.20164M20.0002 8.25C20.0002 11.9779 16.9782 15 13.2502 15C9.52232 15 6.50024 11.9779 6.50024 8.25C6.50024 4.52208 9.52232 1.5 13.2502 1.5C16.9782 1.5 20.0002 4.52208 20.0002 8.25ZM2.83909 25.4075C5.23055 21.8168 9.0043 19.5 13.2502 19.5C17.4962 19.5 21.2699 21.8168 23.6614 25.4075C24.1853 26.1941 24.4473 26.5874 24.4171 27.0899C24.3936 27.4811 24.1372 27.96 23.8246 28.1964C23.4231 28.5 22.871 28.5 21.7667 28.5H4.73378C3.6295 28.5 3.07736 28.5 2.6759 28.1964C2.36332 27.96 2.10688 27.4811 2.08339 27.0899C2.05324 26.5874 2.31519 26.1941 2.83909 25.4075Z"
                stroke="#7F56D9"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span className="text-base font-semibold text-[#42307D] dark:text-[#F7F7F7] mt-3">Contacts</span>
          </div>

          {/* Companies Selection */}
          <div
            onClick={() => setImportType("Company")}
            className={`flex flex-col items-center justify-center border-2 p-6 rounded-lg cursor-pointer transition-all w-1/2 ${
              importType === "Company"
                ? "bg-[#F9F5FF] dark:bg-[#22262F] border border-violet-400 dark:border-violet-600 shadow-sm"
                : "bg-background border border-border text-purple-500 shadow-sm"
            }`}
          >
            <svg width="34" height="30" viewBox="0 0 34 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M18.5 13.5H25.7C27.3802 13.5 28.2202 13.5 28.862 13.827C29.4265 14.1146 29.8854 14.5735 30.173 15.138C30.5 15.7798 30.5 16.6198 30.5 18.3V28.5M18.5 28.5V6.3C18.5 4.61984 18.5 3.77976 18.173 3.13803C17.8854 2.57354 17.4265 2.1146 16.862 1.82698C16.2202 1.5 15.3802 1.5 13.7 1.5H8.3C6.61984 1.5 5.77976 1.5 5.13803 1.82698C4.57354 2.1146 4.1146 2.57354 3.82698 3.13803C3.5 3.77976 3.5 4.61984 3.5 6.3V28.5M32 28.5H2M8.75 7.5H13.25M8.75 13.5H13.25M8.75 19.5H13.25"
                stroke="#7F56D9"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span className="text-base font-semibold text-[#42307D] dark:text-[#F7F7F7] mt-3">Companies</span>
          </div>
        </div>

        <div className="flex flex-col mt-3">
          <Button
            onClick={() => {
              goToNextStep();
              captureEvent("BLE_SelectImportType_NextBtn");
            }}
            className="py-2 px-[14px] w-[60px]"
          >
            Next
          </Button>
        </div>
      </div>
    );
  };

  const renderStep2UploadCSV = () => {
    return (
      <div>
        <div
          className="border-2 rounded-lg p-4 text-center cursor-pointer border-[#7F56D9]"
          onClick={() => fileInputRef.current.click()}
          onDragOver={handleDragOver}
          onDrop={handleFileDrop}
        >
          <input
            type="file"
            accept=".csv"
            className="hidden"
            onChange={(e) => {
              if (e.target.files.length > 0) {
                setSelectedFile(e.target.files[0]);
                captureEvent("BLE_UploadCSV_FileSelected");
              }
            }}
            ref={fileInputRef}
          />

          {!selectedFile ? (
            <>
              <div className="mx-auto flex justify-center mb-4">
                <LucideUploadCloud className="h-12 w-12 text-gray-400" />
              </div>
              <div className="block text-text-600 text-center">
                <p>
                  <span
                    className="text-brand-700 font-semibold"
                    onClick={() => {
                      captureEvent("BLE_UploadCSVModal_ClickToUpload");
                    }}
                  >
                    Click to upload
                  </span>{" "}
                  or drag and drop
                </p>
                <div className="mt-1">
                  <span className="font-semibold">CSV format</span> (max. 1MB size, up to 5,000 rows and up to
                  50 columns)
                </div>
              </div>
            </>
          ) : (
            <div className="flex justify-between space-x-4">
              <div className="flex">
                <div className="p-2">
                  <Image src="/images/icons/untitledui/csv-icon.svg" className="no-invert" />
                </div>
                <div className="text-left ml-2 mt-1">
                  <p className="font-medium">{selectedFile.name}</p>
                  <p className="text-sm text-gray-500">{formatFileSize(selectedFile.size)}</p>
                </div>
              </div>
              <button
                className="flex items-center justify-center rounded-md text-red-500 border border-[#FDA29B] w-10 h-10 mt-2"
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedFile(null);
                  captureEvent("BLE_UploadCSV_RemoveFile");
                }}
              >
                <TrashIcon className="h-5 w-5" />
              </button>
            </div>
          )}
        </div>

        <div className="mt-6 flex space-x-3">
          <Button
            variant="outline"
            onClick={() => {
              goBackStep();
              captureEvent("BLE_UploadCSV_BackBtn");
            }}
          >
            Back
          </Button>
          <Button
            onClick={() => {
              handleUploadCSV();
              captureEvent("BLE_UploadCSV_NextBtn");
            }}
            disabled={!selectedFile || isFileUploading}
          >
            Next
            {isFileUploading && <div className="loader_circle ml-2"></div>}
          </Button>
        </div>
      </div>
    );
  };

  const renderStep3MapColumns = () => {
    return (
      <div>
        <div className="mt-3 flow-root">
          <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
              <div className="overflow-hidden border border-border rounded-[--radius]">
                <table className="min-w-full divide-y divide-border" style={{ tableLayout: "fixed" }}>
                  <thead className="bg-background">
                    <tr>
                      <th
                        className="px-3 py-3.5 text-left text-sm font-medium text-text-600"
                        style={{ width: "30%" }}
                      >
                        Property
                      </th>
                      <th
                        className="px-3 py-3.5 text-left text-sm font-medium text-text-600"
                        style={{ width: "40%" }}
                      >
                        Your CSV Column
                      </th>
                      <th
                        className="px-3 py-3.5 text-left text-sm font-medium text-text-600"
                        style={{ width: "30%" }}
                      >
                        Preview
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-border bg-background">
                    {csvResponse &&
                      csvResponse.mapping_columns &&
                      Object.entries(csvResponse.mapping_columns).map(([key]) => {
                        if (csvResponse?.enrichment_type) {
                          if (
                            !["linkedin_url", "company_name", "company_domain"].includes(key) &&
                            csvResponse?.enrichment_type === "Company"
                          ) {
                            return null;
                          }
                          return (
                            <tr key={key}>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-text-600">
                                <div className="inline-flex items-center">
                                  {csvResponse.mapping_columns[key]}{" "}
                                  {key === "linkedin_url" && <Badge className={"ml-2"}>Recommended</Badge>}
                                </div>
                              </td>
                              <td className="whitespace-nowrap px-3 py-4 text-sm text-text-600">
                                {showHide && (
                                  <select
                                    className={`h-11 px-4 py-3 text-sm w-9/12 rounded-[--radius] border border-border bg-background text-foreground ${
                                      predictedMapping &&
                                      predictedMapping[key] &&
                                      predictedMapping[key].value &&
                                      predictedMapping[key].value
                                        ? "border border-green-500"
                                        : ""
                                    } ${
                                      key === "linkedin_url" &&
                                      csvResponse &&
                                      csvResponse.sample_record &&
                                      newMappingOfCSVCols &&
                                      newMappingOfCSVCols[key] >= 0 &&
                                      csvResponse.sample_record[newMappingOfCSVCols[key]] &&
                                      !isLinkedInURL(csvResponse.sample_record[newMappingOfCSVCols[key]])
                                        ? "border-red-500"
                                        : ""
                                    }`}
                                    onChange={(e) => {
                                      handleChangeCSVColumn(e.target.value, key);
                                      captureEvent("BLE_CSVEnrichmentMap_SelectColumnDropdown", {
                                        csv_column: key,
                                      });
                                    }}
                                    onClick={() => {
                                      captureEvent("BLE_CSVEnrichmentMap_SelectColumnDropdown");
                                    }}
                                  >
                                    <option value="">Select</option>
                                    {csvResponse.header.map((item, index) => (
                                      <option
                                        key={index}
                                        selected={
                                          csvResponse.sample_record &&
                                          newMappingOfCSVCols &&
                                          newMappingOfCSVCols[key] >= 0 &&
                                          csvResponse.header[newMappingOfCSVCols[key]] &&
                                          item &&
                                          csvResponse.header[newMappingOfCSVCols[key]].trim() === item.trim()
                                        }
                                        value={index}
                                      >
                                        {item}
                                      </option>
                                    ))}
                                  </select>
                                )}
                                {key === "linkedin_url" &&
                                  csvResponse &&
                                  csvResponse.sample_record &&
                                  newMappingOfCSVCols &&
                                  newMappingOfCSVCols[key] >= 0 &&
                                  csvResponse.sample_record[newMappingOfCSVCols[key]] && (
                                    <>
                                      {isLinkedInURL(csvResponse.sample_record[newMappingOfCSVCols[key]]) ? (
                                        <></>
                                      ) : (
                                        <>
                                          {csvResponse.enrichment_type === "People" && (
                                            <span className="text-red-500 block text-[12px]">
                                              One or more LinkedIn profiles URLs are invalid. <br /> Make sure
                                              they follow this format:
                                              "https://www.linkedin.com/in/profilename.
                                            </span>
                                          )}
                                          {csvResponse.enrichment_type === "Company" && (
                                            <span className="text-red-500 block text-[12px]">
                                              One or more LinkedIn company URLs are invalid. <br /> Make sure
                                              they follow this format:
                                              "https://www.linkedin.com/company/apple.
                                            </span>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                              </td>
                              <td
                                className="truncate px-3 py-4 text-sm text-text-600"
                                title={
                                  csvResponse &&
                                  csvResponse.sample_record &&
                                  newMappingOfCSVCols &&
                                  newMappingOfCSVCols[key] >= 0 &&
                                  csvResponse.sample_record[newMappingOfCSVCols[key]]
                                }
                              >
                                {csvResponse &&
                                  csvResponse.sample_record &&
                                  newMappingOfCSVCols &&
                                  newMappingOfCSVCols[key] >= 0 &&
                                  (csvResponse.sample_record[newMappingOfCSVCols[key]]?.length > 80
                                    ? csvResponse.sample_record[newMappingOfCSVCols[key]].substring(0, 50) +
                                      "......"
                                    : csvResponse.sample_record[newMappingOfCSVCols[key]])}
                              </td>
                            </tr>
                          );
                        }
                        return null;
                      })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-6 flex space-x-3">
          <Button variant="outline" onClick={goBackStep}>
            Back
          </Button>

          <Button
            onClick={() => {
              if (csvResponse && csvResponse?.enrichment_type === "Company") {
                goToNextStep(); // For Company, go to the next step (Finalize)
              } else {
                goToNextStep(); // For People, continue to next step
              }
              captureEvent("BLE_CSVEnrichmentMap_NextBtn");
            }}
            disabled={!newMappingOfCSVCols || Object.keys(newMappingOfCSVCols).length === 0}
          >
            Next
          </Button>
        </div>
      </div>
    );
  };

  const renderStep4EnrichmentType = () => {
    return (
      <div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-8">
          <div
            className={`rounded-xl p-6 flex flex-col items-center cursor-pointer bg-background ${
              enrichmentTypeValue === "Email or Phone"
                ? "border-brand-600 border-2 dark:bg-[#22262F]"
                : "border border-[#EAECF0]"
            }`}
            onClick={() => {
              setEnrichmentTypeValue("Email or Phone");
              captureEvent("BLE_CSVEnrichmentContacts_AnyAvailableDataBtn");
            }}
          >
            <Image src={"/images/icons/type_any.png"} className="rounded no-invert" width={58} height={48} />
            <h3 className="mt-6 text-lg font-semibold leading-6 text-text-900 text-center">
              Any Available Data
            </h3>
            <p className="text-xs text-text-600 leading-6 mt-2 text-center">
              Enrich with all available data including phone, email, company details etc.
            </p>
          </div>

          <div
            className={`rounded-xl p-6 flex flex-col items-center cursor-pointer  bg-background ${
              enrichmentTypeValue === "Email"
                ? "border-brand-600 border-2 dark:bg-[#22262F]"
                : "border border-[#EAECF0]"
            }`}
            onClick={() => {
              setEnrichmentTypeValue("Email");
              captureEvent("BLE_CSVEnrichmentContacts_EmailBtn");
            }}
          >
            <Image
              src={"/images/icons/type_Email_new.png"}
              className="rounded no-invert"
              width={58}
              height={48}
            />
            <h3 className="mt-6 text-lg font-semibold leading-6 text-text-900">Email</h3>
            <p className="text-xs text-text-600 leading-6 mt-2 text-center">
              Enrich contacts with work email addresses
            </p>
          </div>

          <div
            className={`rounded-xl p-6 flex flex-col items-center cursor-pointer bg-background ${
              enrichmentTypeValue === "Phone"
                ? "border-brand-600 border-2 dark:bg-[#22262F]"
                : "border border-[#EAECF0]"
            }`}
            onClick={() => {
              setEnrichmentTypeValue("Phone");
              captureEvent("BLE_CSVEnrichmentContacts_PhoneBtn");
            }}
          >
            <Image
              src={"/images/icons/type_Phone.svg"}
              className="rounded no-invert"
              width={58}
              height={48}
            />
            <h3 className="mt-6 text-lg font-semibold leading-6 text-text-900">Phone</h3>
            <p className="text-xs text-text-600 leading-6 mt-2 text-center">Must contain phone numbers</p>
          </div>

          <div
            className={`rounded-xl p-6 flex flex-col items-center cursor-pointer  bg-background ${
              enrichmentTypeValue === "Email and Phone"
                ? "border-brand-600 border-2 dark:bg-[#22262F]"
                : "border border-[#EAECF0]"
            }`}
            onClick={() => {
              setEnrichmentTypeValue("Email and Phone");
              captureEvent("BLE_CSVEnrichmentContacts_EmailAndPhoneBtn");
            }}
          >
            <Image
              src={"/images/icons/type_phoneEmail.png"}
              className="rounded no-invert"
              width={58}
              height={48}
            />
            <h3 className="mt-6 text-lg font-semibold leading-6 text-text-900">Phone and Email</h3>
            <p className="text-xs text-text-600 leading-6 mt-2 text-center">
              Must contain email addresses and phone numbers
            </p>
          </div>
        </div>

        <div className="inline-flex items-center">
          <Switch
            checked={autoVerify}
            onCheckedChange={(checked) => {
              setAutoVerify(checked);
            }}
          />
          <span className="ml-3">Auto verify</span>
        </div>

        <div className="mt-6 flex space-x-3">
          <Button variant="outline" onClick={goBackStep}>
            Back
          </Button>
          <Button
            onClick={() => {
              if (isDataLoaded && integrations.length > 1) {
                goToNextStep();
              } else {
                goToNextStep(true); // Skip provider step and go directly to finalize
              }
              captureEvent("BLE_CSVEnrichmentContacts_NextBtn");
            }}
          >
            Next
          </Button>
        </div>
      </div>
    );
  };

  const renderStep5ProviderPriority = () => {
    return (
      <div>
        <ul ref={sortableContainer} className="space-y-2 mb-6">
          {integrations.map((integration) => (
            <li
              key={integration.id}
              data-id={integration.id}
              className="rounded-xl border-2 border-brand-600 py-3 px-4 flex justify-between items-center"
              onClick={() => captureEvent("BLE_CSVEnrichmentContactsCustomizeProvidersAndPriority_ChooseBtn")}
            >
              <div className="flex items-center">
                <input
                  type="checkbox"
                  checked={activeIntegrations.includes(integration.id)}
                  onChange={(e) => handleCheckboxChange(integration.id, e.target.checked)}
                  className="mr-2 h-4 w-4 rounded border-gray-300 text-brand-700 focus:ring-brand-700 dark:text-brand-200"
                  onClick={(e) => e.stopPropagation()}
                />
                <span className="flex items-center">
                  {logos[integration?.integration?.key] && (
                    <span
                      className="svg__24 mr-2 inline-block rounded-[--radius] p-1 bg-white"
                      dangerouslySetInnerHTML={{
                        __html: logos[integration?.integration?.key],
                      }}
                    />
                  )}
                  <span>{integration.name}</span>
                </span>
              </div>

              {/* Drag handle */}
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12 6.5C12.5523 6.5 13 6.05228 13 5.5C13 4.94772 12.5523 4.5 12 4.5C11.4477 4.5 11 4.94772 11 5.5C11 6.05228 11.4477 6.5 12 6.5Z"
                  stroke="#344054"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 13.5C12.5523 13.5 13 13.0523 13 12.5C13 11.9477 12.5523 11.5 12 11.5C11.4477 11.5 11 11.9477 11 12.5C11 13.0523 11.4477 13.5 12 13.5Z"
                  stroke="#344054"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 20.5C12.5523 20.5 13 20.0523 13 19.5C13 18.9477 12.5523 18.5 12 18.5C11.4477 18.5 11 18.9477 11 19.5C11 20.0523 11.4477 20.5 12 20.5Z"
                  stroke="#344054"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M19 6.5C19.5523 6.5 20 6.05228 20 5.5C20 4.94772 19.5523 4.5 19 4.5C18.4477 4.5 18 4.94772 18 5.5C18 6.05228 18.4477 6.5 19 6.5Z"
                  stroke="#344054"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M19 13.5C19.5523 13.5 20 13.0523 20 12.5C20 11.9477 19.5523 11.5 19 11.5C18.4477 11.5 18 11.9477 18 12.5C18 13.0523 18.4477 13.5 19 13.5Z"
                  stroke="#344054"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M19 20.5C19.5523 20.5 20 20.0523 20 19.5C20 18.9477 19.5523 18.5 19 18.5C18.4477 18.5 18 18.9477 18 19.5C18 20.0523 18.4477 20.5 19 20.5Z"
                  stroke="#344054"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M5 6.5C5.55228 6.5 6 6.05228 6 5.5C6 4.94772 5.55228 4.5 5 4.5C4.44772 4.5 4 4.94772 4 5.5C4 6.05228 4.44772 6.5 5 6.5Z"
                  stroke="#344054"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M5 13.5C5.55228 13.5 6 13.0523 6 12.5C6 11.9477 5.55228 11.5 5 11.5C4.44772 11.5 4 11.9477 4 12.5C4 13.0523 4.44772 13.5 5 13.5Z"
                  stroke="#344054"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M5 20.5C5.55228 20.5 6 20.0523 6 19.5C6 18.9477 5.55228 18.5 5 18.5C4.44772 18.5 4 18.9477 4 19.5C4 20.0523 4.44772 20.5 5 20.5Z"
                  stroke="#344054"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </li>
          ))}
        </ul>

        <div className="mt-6 flex space-x-3">
          <Button variant="outline" onClick={goBackStep}>
            Back
          </Button>
          <Button
            onClick={() => {
              goToNextStep();
              captureEvent("BLE_CSVEnrichmentContacts_ConfigureProviderNextBtn");
            }}
          >
            Next
          </Button>
        </div>
      </div>
    );
  };

  const renderStep6Finalize = () => {
    // Get file size from csvResponse
    const getFileSize = () => {
      if (selectedFile?.size) {
        return formatFileSize(selectedFile.size);
      } else if (csvResponse?.size) {
        return formatFileSize(csvResponse.size);
      } else if (csvResponse?.fileSize) {
        return formatFileSize(csvResponse.fileSize);
      } else if (csvResponse?.originalFile?.size) {
        return formatFileSize(csvResponse.originalFile.size);
      } else if (csvResponse?.file?.size) {
        return formatFileSize(csvResponse.file.size);
      } else if (csvResponse?.total_records) {
        return `${csvResponse.total_records} records`;
      } else if (csvResponse?.rows?.length) {
        return `${csvResponse.rows.length} records`;
      } else {
        return "File uploaded";
      }
    };

    return (
      <div>
        <div className="flex gap-3 mb-0">
          {/* File details */}
          <div className="flex items-start p-4 bg-background border border-border rounded-lg flex-1">
            <div className="rounded flex-shrink-0 mr-2">
              <Image src="/images/icons/untitledui/csv-icon.svg" className="no-invert" />
            </div>
            <div>
              <h3 className="font-medium text-foreground text-sm">{csvResponse?.name || "CSV File"}</h3>
              <p className="text-sm text-[#475467] font-normal">{getFileSize()}</p>
            </div>
          </div>

          {/* Selected enrichment type */}
          {csvResponse?.enrichment_type !== "Company" && importType !== "Company" && (
            <div className="flex items-start p-4 bg-background border border-border rounded-lg flex-1">
              <div className="rounded flex-shrink-0 mr-2">
                <div className="w-10 h-10 flex items-center justify-center">
                  <Image
                    src={
                      enrichmentTypeValue === "Email"
                        ? "/images/icons/type_Email_new.png"
                        : enrichmentTypeValue === "Phone"
                          ? "/images/icons/type_Phone.svg"
                          : enrichmentTypeValue === "Email and Phone"
                            ? "/images/icons/type_phoneEmail.png"
                            : "/images/icons/type_any.png"
                    }
                    className="w-full h-full"
                    alt="Import type"
                  />
                </div>
              </div>
              <div>
                <h3 className="font-medium text-sm">{enrichmentTypeValue}</h3>
                <p className="text-sm text-gray-500">
                  {enrichmentTypeValue === "Email and Phone"
                    ? "Must contain email addresses and phone numbers"
                    : enrichmentTypeValue === "Email"
                      ? "Enrich contacts with work email addresses"
                      : enrichmentTypeValue === "Phone"
                        ? "Must contain phone numbers"
                        : "Enrich with all available data including phone, email, company details etc"}
                </p>
              </div>
            </div>
          )}
        </div>

        {/* Tags section */}
        {/* <div className="mb-6">
          <h3 className="font-medium mb-[6px] text-[#344054] text-sm">Add tags</h3>
          <div className="relative">
            <div className="flex flex-wrap items-center gap-2 mb-2 py-2 px-3 border border-[#D0D5DD] shadow-sm rounded-md bg-background min-h-11">
              {tags.map(tag => (
                <div key={tag} className="bg-background border border-[#D0D5DD] rounded-md px-2 py-1 text-sm flex items-center">
                  {tag}
                  <button
                    type="button"
                    className="ml-1.5 text-gray-500"
                    onClick={() => removeTag(tag)}
                  >
                    <X className="h-3 w-3" />
                  </button>
                </div>
              ))}
              <input
                type="text"
                value={tagInput}
                onChange={(e) => setTagInput(e.target.value)}
                onKeyDown={handleKeyDown}
                className="flex-grow border-none outline-none bg-transparent text-foreground"
                placeholder={tags.length > 0 ? "" : "Add tag..."}
              />
            </div>
          </div>
          <p className="text-xs text-gray-500 mt-2">
            Adding tags can help you identify these records by filtering them from list of all the records
          </p>
        </div> */}

        {shouldShowMapColumnsAlert ? (
          <div className="mt-6">
            <Button
              variant="outline"
              onClick={cancelProcess}
              className="text-[#B42318] dark:text-[#FECDCA] dark:bg-[#55160C] border-[#FDA29B] dark:border-[#912018]  font-semibold hover:bg-destructive/10 py-2 px-3"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mr-2"
              >
                <path
                  d="M15.8337 10.0001H4.16699M4.16699 10.0001L10.0003 15.8334M4.16699 10.0001L10.0003 4.16675"
                  stroke="currentColor"
                  strokeWidth="1.67"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Cancel and go back
            </Button>
          </div>
        ) : (
          <div className="mt-6 flex space-x-3">
            <Button variant="outline" onClick={goBackStep}>
              Back
            </Button>
            <Button
              onClick={() => {
                handleEnrichCSVMapColumns();
                captureEvent("BLE_CSVEnrichmentFinalize_StartBtn");
              }}
              disabled={enrichCSVMapColumnsFn.isLoading}
            >
              Looks good!
              {enrichCSVMapColumnsFn.isLoading && <div className="loader_circle ml-2"></div>}
            </Button>
          </div>
        )}
      </div>
    );
  };

  const renderWizardContent = () => {
    switch (currentStep) {
      case 1:
        return renderStep1ImportType();
      case 2:
        return renderStep2UploadCSV();
      case 3:
        return renderStep3MapColumns();
      case 4:
        if (currentImportType === "Company") {
          return renderStep6Finalize(); // For Company, step 4 is the finalize step
        } else {
          return renderStep4EnrichmentType(); // For People
        }
      case 5:
        return renderStep5ProviderPriority(); // Only for People
      case 6:
        return renderStep6Finalize(); // Only for People
      default:
        return null;
    }
  };

  const isOwnerOrAdmin = activeWorkspace?.role === "Owner" || activeWorkspace?.role === "Admin";
  const shouldShowMapColumnsAlert = mapColumnsError?.status === 402 || mapColumnsError?.status === 403;
  const mapColumnsAlertCTA =
    shouldShowMapColumnsAlert && isOwnerOrAdmin ? (
      <Button asChild>
        <a
          href={`${process.env.REACT_APP_BASE_URL}/${process.env.REACT_APP_APP_HOME}/${activeWorkspace?.slug}/${
            mapColumnsError?.status === 402 ? "settings/billing/plans" : "settings/teams"
          }`}
        >
          {mapColumnsError?.status === 402 ? "View plans" : "Manage team access"}
        </a>
      </Button>
    ) : null;

  return (
    <div id="UploadContactsWizard">
      <Breadcrumb>
        <BreadcrumbList>
          <BreadcrumbItem>
            <NavAnchor to={`/`}>
              <Image src="/images/icons/untitledui/home.svg" width="16" height="16" />
            </NavAnchor>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                cancelProcess(); // Call the same function used in the cancel button
              }}
              className="cursor-pointer"
            >
              CSV Enrichment
            </a>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>
              {csvResponse?.enrichment_type === "People" || importType === "People"
                ? "Contacts"
                : csvResponse?.enrichment_type || importType}
            </BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      <div className="flex justify-between items-center mt-4">
        <h2 className="text-xl font-semibold">Import contacts or companies</h2>
        <Button
          variant="outline"
          onClick={cancelProcess}
          className="text-[#B42318] dark:text-[#FECDCA] dark:bg-[#55160C] border-[#FDA29B] dark:border-[#912018]  font-semibold hover:bg-destructive/10 py-2 px-3"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="mr-2"
          >
            <path
              d="M15.8337 10.0001H4.16699M4.16699 10.0001L10.0003 15.8334M4.16699 10.0001L10.0003 4.16675"
              stroke="currentColor"
              strokeWidth="1.67"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Cancel and go back
        </Button>
      </div>

      <p className="text-text-600 mt-1 mb-6">
        Credits will be consumed only for contacts we match in your file
      </p>

      {shouldShowMapColumnsAlert && (
        <AlertTag
          icon="/images/icons/untitledui/alert-error.svg"
          heading={mapColumnsError?.title || "Permissions denied"}
          description={mapColumnsError?.message || ""}
          dismiss={false}
          cta={mapColumnsAlertCTA}
        />
      )}

      {/* Wizard Steps with Content */}
      <WizardSteps currentStep={currentStep} importType={currentImportType} onStepClick={handleStepClick}>
        {renderWizardContent()}
      </WizardSteps>

      {/* Modal for column mapping confirmation */}
      {openConfirmModal && (
        <ConfirmModal
          openModal={openConfirmModal}
          modalType={openConfirmModalType}
          confirmModalState={() => setOpenConfirmModal(false)}
        />
      )}
      <GenericModal
        isOpen={overRideMapColumn.newkey !== null}
        closeModal={() => {
          setOverRideMapColumn({
            newkey: null,
            oldkey: null,
            index: null,
          });
        }}
      >
        <div className="mt-3 text-center sm:mt-0 sm:text-left max-w-[500px]">
          <h3 className="text-xl font-bold leading-6 text-foreground">This column has already been mapped</h3>
          <div className="mt-5">
            <p className="text-sm text-gray-500">
              Would you like to remove your selection from{" "}
              <span className="font-bold text-foreground">
                "
                {csvResponse &&
                  csvResponse.mapping_columns &&
                  overRideMapColumn &&
                  overRideMapColumn.oldkey &&
                  csvResponse.mapping_columns[overRideMapColumn.oldkey]}
                "
              </span>{" "}
              property and map it to{" "}
              <span className="font-bold text-foreground">
                "
                {csvResponse &&
                  csvResponse.mapping_columns &&
                  overRideMapColumn &&
                  overRideMapColumn.newkey &&
                  csvResponse.mapping_columns[overRideMapColumn.newkey]}
                "
              </span>{" "}
              property?
            </p>
          </div>
          <div className="mt-5 flex items-center space-x-3">
            <Button
              variant="outline"
              onClick={() => {
                setShowHide(false);
                setTimeout(() => {
                  setShowHide(true);
                }, 10);
                setOverRideMapColumn({
                  newkey: null,
                  oldkey: null,
                  index: null,
                });
              }}
            >
              No
            </Button>
            <Button
              type="button"
              onClick={() => {
                handleChangeCSVColumn(overRideMapColumn?.index, overRideMapColumn?.newkey, true);
              }}
            >
              Yes
            </Button>
          </div>
        </div>
      </GenericModal>
    </div>
  );
}
